// import dJSON from 'dirty-json';
// import '../node_modules/@lottiefiles/lottie-player/dist/lottie-player';

import './js/base/base-start';
import './js/global';

// modules - core
import './modules/core/accordion/module';

// modules
import './modules/evox/shop-all/module';
import './modules/theme/hero-slider/module';
import './modules/evox/category-cards/module';
import './modules/evox/merch-slider/module';
import './modules/evox/brand-pattern/module';
import './modules/theme/what-makes-us-special/module';
import './modules/theme/postit-polaroid/module';
import './modules/theme/catalogues/module';
import './modules/theme/testimonials/module';
import './modules/evox/locations/module';
import './modules/theme/cta-sticky/module';
import './modules/theme/category-cards-json/module';
import './modules/evox/contact-form/module';
// layouts

// leave me last
import './js/base/base-end';
